import Swiper from '../../common/custom-swiper/custom-swiper';

export default new class blogPostContentSlider {
  constructor() {
    this.sliderDocumentContainerSelector = 'offer-of-services__container';
    this.slideDocumentSelector = 'offer-of-services__slide';
    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  init() {
    const sliderDocument = document.querySelector(`.${this.sliderDocumentContainerSelector}`);

    if (!sliderDocument) return;

    this.blogSlider = new Swiper(`.${this.sliderDocumentContainerSelector}`, {
      slidesPerView: 1.5,
      slidesPerColumn: 1,
      slidesPerGroup: 1,
      spaceBetween: 15,
      breakpointsInverse: true,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      observer: true,
      breakpoints: {
        768: {
          slidesPerColumn: 3,
          slidesPerGroup: 3,
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1200: {
          slidesPerColumn: 2,
          slidesPerGroup: 2,
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    });
  }
}();
